// NotificationPage.tsx

import React, { useEffect, useState } from "react";
import "./NotificaionPage.css";
import Header from "../../Components/Header/Header";
import { videoCreatorEndPoint } from "../../Constants/constants";
import { callApi } from "../../utils/apiService";
import { formatNotificationDate } from "../../utils/helpers";
import PaginationLeft from "../../assets/images/pagination-left-arrow.svg";
import PaginationRight from "../../assets/images/pagination-right-arrow.svg";

const NotificationPage = () => {
  const [notificationData, setNotificationData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    totalNotifications: 0,
    totalPages: 0,
    page: 1,
    limit: 10,
  });

  const fetchNotifications = async (page = 1) => {
    try {
      const response = await callApi(
        `${videoCreatorEndPoint}creatorData/notifications/list?page=${page}&limit=10`,
        "GET",
      );

      if (response?.status) {
        setNotificationData(response.data?.notifications || []);
        setPagination(response.data?.pagination || {});
      }
    } catch (error) {
      console.error("Language API Error:", error);
    }
  };

  useEffect(() => {
    fetchNotifications(currentPage);
  }, [currentPage]);

  const pageNumbers = Array.from(
    { length: pagination.totalPages || 0 },
    (_, index) => index + 1,
  );

  const showingFrom =
    pagination.totalNotifications === 0
      ? 0
      : (currentPage - 1) * pagination.limit + 1;

  const showingTo = Math.min(
    currentPage * pagination.limit,
    pagination.totalNotifications,
  );

  return (
    <div className="dashboard">
      <div className="dashboard-bg-stripe"></div>
      <Header />
      <div className="notification-page">
        <div className="notification-card">
          <div className="notification-header">
            <span>Notification</span>
            <div className="notification-count">
              {pagination.totalNotifications || 0}
            </div>
          </div>

          <div className="notification-list">
            {notificationData?.map((item) => (
              <div className="notification-item" key={item?._id}>
                <div className="purple-dot" />
                {item?.userDetails?.profileUrl &&
                item?.userDetails?.profileUrl !== "" ? (
                  <img
                    src={item?.userDetails?.profileUrl}
                    alt="profile"
                    className="profile-img"
                  />
                ) : (
                  <div className="system-icon">◔</div>
                )}

                <div className="notification-content">
                  <p>{item?.message}</p>
                  <span>{formatNotificationDate(item?.createdAt)}</span>
                </div>
              </div>
            ))}
            <div className="pagination-wrapper">
              <span className="content-pagination-info">
                Showing{" "}
                <span className="content-pagination-count">
                  {showingFrom}-{showingTo}
                </span>{" "}
                from{" "}
                <span className="content-pagination-count">
                  {pagination.totalNotifications}
                </span>{" "}
                data
              </span>

              <div className="pagination-controls">
                <img
                  src={PaginationLeft}
                  alt="Previous"
                  style={{
                    width: "32px",
                    height: "32px",
                    cursor: currentPage > 1 ? "pointer" : "not-allowed",
                    opacity: currentPage > 1 ? 1 : 0.5,
                  }}
                  onClick={() =>
                    currentPage > 1 && setCurrentPage((prev) => prev - 1)
                  }
                />

                {pageNumbers.map((page) => (
                  <button
                    key={page}
                    className={`content-pagination-btn ${
                      currentPage === page ? "active" : ""
                    }`}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                ))}

                <img
                  src={PaginationRight}
                  alt="Next"
                  style={{
                    width: "32px",
                    height: "32px",
                    cursor:
                      currentPage < pagination.totalPages
                        ? "pointer"
                        : "not-allowed",
                    opacity: currentPage < pagination.totalPages ? 1 : 0.5,
                  }}
                  onClick={() =>
                    currentPage < pagination.totalPages &&
                    setCurrentPage((prev) => prev + 1)
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationPage;
